import clsx from 'clsx';
import React from 'react';
import { useMemo, useState } from 'react';
import { LeftArrow } from '../../icons/arrows/leftArrow';
import { CollapseIcon, ExpandIcon } from '../../icons/expandIcon';
import { TabList } from '../ui/TabList';
import { useNavigate } from 'react-router';
import moment from 'moment';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';


export const InfoDrawer = ({ data }) => {
  const image = `https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${data.carTitle.split(' ')[0]}&modelFamily=${data.carTitle.split(' ')[1]}&modelYear=${data.ModelYear}&zoomType=fullScreen&width=400&angle=28`
  const [carModal, setCarModal] = useState(false)
  const [expanded, setExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const selectView = useMemo(() => {
    if (!expanded) {
      return (
        <div className="flex flex-col gap-12 max-lg:hidden">
          <div className="flex flex-col gap-2.5">
            <p className="font-[700] text-sm">{data.carTitle}</p>
            <p className="text-[#6A6A6A] text-xs">{data.carSubTitle}</p>
            <img alt={data.carTitle} src={image} />
            <div className="flex w-full justify-between">
              <div className="flex flex-col gap-2.5">
                <p className="font-[700] text-sm">
                  {data.installment.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€/μήνα 
                </p>
                <p className="text-xs text-[#6A6A6A]">
                  {(data.installment * data.VATTax).toLocaleString('el-GR', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 2,
                  })}€ με ΦΠΑ 24%
                </p>
              </div>
              <div className="flex flex-col gap-2.5 items-end">
                <p className="text-xs text-[#6A6A6A]">Κωδικός Προσφοράς</p>
                <p className="font-[700] text-sm">{data.cncode}</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <h4>Προαιρετικός Εξοπλισμός</h4>
            <p className="font-[600] text-xs">
              {data.extras.length} επιλογ{data.extras.length ===1 ? 'ή' : 'ές'}
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <h4>Όροι Συμβολαίου</h4>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col text-xs">
                <p className="font-[700]">Προκαταβολή</p>
                <p>{data.initialDeposit.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€</p>
              </div>
              <div className="flex flex-col text-xs">
                <p className="font-[700]">Χλμ/έτος</p>
                <p>{data.annualKm.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}</p>
              </div>
              <div className="flex flex-col text-xs">
                <p className="font-[700]">Διάρκεια</p>
                <p className='text-body'>{data.numOfPayments} μήνες</p>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col gap-6 w-full max-lg:pt-6">
          <div className="flex flex-col items-center w-full gap-1">
            <div className="flex justify-between w-full">
              <div className="flex flex-col">
                <h3>{data.carTitle}</h3>
                <p className="text-[#6A6A6A] text-xs">{data.carSubTitle}</p>
              </div>
              <div className="flex flex-col items-end">
                <h3>
                  {data.installment.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€/μήνα
                </h3>
                <p className="text-xs  text-[#6A6A6A]">
                  {(data.installment * data.VATTax).toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€ με ΦΠΑ 24%
                </p>
              </div>
            </div>
            <img alt='' width={300} src={image} />
          </div>
          <TabList
            tabs={['Βασικές Πληροφορίες', 'Προαιρετικός Εξοπλισμός', 'Συμβόλαιο']}
            active={activeTab}
            setActive={(idx) => {
              setActiveTab(idx);
            }}
            wrapperClassName={'border-none text-body'}
          />
          <div className="h-[30vh] overflow-auto pl-6">{
            activeTab === 1 ?
              data.extras.map(item => <h6>{item}</h6>) :
              activeTab === 0 ? 
                <div className='flex flex-col gap-6'>
                  <div>
                    <h6>Ημερομηνία Προσφοράς</h6>
                    <p className='text-label'>{moment(data.requestDate).format('DD/MM/YYYY')}</p>
                  </div>
                  {data && data.color !== '' && <div>
                    <h6>Χρώμα</h6>
                    <p className='text-label'>{data.color}</p>
                  </div>} 
                </div> :
                 <div className='flex flex-col gap-6'>
                  <div>
                    <h6>Διάρκεια</h6>
                    <p className='text-body'>{data.numOfPayments} μήνες</p>
                  </div> 
                  <div className="flex flex-col text-xs">
                    <h6>Προκαταβολή</h6>
                    <p>{data.initialDeposit.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}€</p>
                  </div>
                  <div className="flex flex-col text-xs">
                    <h6>Χλμ/έτος</h6>
                    <p>{data.annualKm.toLocaleString('el-GR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}</p>
                  </div>
               </div>
          }</div>
        </div>
      );
    }
  }, [expanded, activeTab]);

  return (
    <>
      <div
        className={
          expanded ? 'max-lg:hidden fixed inset-0 h-full z-10 bg-[#000000]/40' : 'hidden'
        }
      />
      <div className="max-lg:hidden sticky top-0 z-10 w-fit" style={{
        height: 'calc(100vh - 186px)'
      }}>
        <div className="flex h-full">
          <div
            className={clsx(
              'no-scrollbar overflow-y-scroll py-8 px-12 bg-white rounded-r-[20px] h-[105%] transition-all ease-in-out duration-200',
              expanded ? 'w-[670px]' : 'w-[360px]'
            )}
            style={{
              boxShadow: '0px 2px 6px 6px #63636333',
            }}
          >
            <div
              className="flex gap-6 items-center hover:cursor-pointer mb-11"
              onClick={()=> {navigate('/dashboard')}}
            >
              <LeftArrow />
              <p className="text-subtitle text-[20px]">Επιστροφή</p>
            </div>
            {selectView}
          </div>
          {expanded ? (
            <CollapseIcon
              onClick={() => {
                setExpanded(!expanded);
              }}
              className={'hover:cursor-pointer mt-5'}
            />
          ) : (
            <ExpandIcon
              onClick={() => {
                setExpanded(!expanded);
              }}
              className={'hover:cursor-pointer h-full'}
            />
          )}
        </div>
      </div>
      <Dialog open={carModal} onOpenChange={(open) => { setCarModal(open); setExpanded(open) }}>
            <DialogTrigger>
              <div className="fixed lg:hidden w-full justify-between bg-white rounded-t-[12px] bottom-0 z-50 flex p-4" style={{
              boxShadow: '0px -8px 10px 0px #0000000D',
              bottom: '0px'
                }}>
                <div className='w-full flex justify-center mt-2 absolute'>
                  <div className='w-[60px] h-[2px] rounded-full bg-[#E2E2E2]'/>
                </div>
                <div className='flex flex-col gap-1 pt-4'>
                  <h4 className='text-start'>{data.carTitle}</h4>
                  <p className='text-disclaimer text-start'>{data.installment}€ monthly</p>
              </div>
            <img alt='' className={'pt-4'} width={100} src={image} />
              </div>
            </DialogTrigger>
            <DialogContent blurred={false} className="p-3 h-[calc(100%_-_76px)] z-[100]">
          <div typeof='button' className='w-full flex justify-center mt-2' onClick={() => { setCarModal(!carModal);  setExpanded(!expanded)}}>
                <div className='w-[60px] h-[2px] rounded-full bg-[#E2E2E2]'/>
              </div>
              {selectView}
            </DialogContent>
          </Dialog>
    </>
  );
};
